import { ReactElement } from 'react';
import * as S from './PayPalSection.styles';
import { PaypalCreditIcon } from '@/shared/images/icons/PaypalCreditIcon';
import Link from 'next/link';
import router from 'next/router';
import { useCartContext } from '@/common/app/contexts';

const PayPalSection = (): ReactElement => {
    const { config } = useCartContext();
    const isWishlist = router.pathname === '/wishlist';
    const showPaypal = config && !!+config.enable_paypal_gateway;

    if (!showPaypal) return <></>;

    return (
        <S.PaypalCreditSection isWishlist={isWishlist}>
            <S.PaypalCreditContainer isWishlist={isWishlist}>
                <S.IconAndText>
                    <S.PaypalCredit>
                        <PaypalCreditIcon />
                    </S.PaypalCredit>
                    No Interest if paid in full in 6 months on purchases of $99.00+
                </S.IconAndText>
                <S.PaypalText>
                    Available during checkout.
                    <Link href="https://www.paypal.com/us/webapps/mpp/terms/paypal-credit" passHref>
                        <S.SeeMore target="_blank">See terms</S.SeeMore>
                    </Link>
                </S.PaypalText>
            </S.PaypalCreditContainer>
        </S.PaypalCreditSection>
    );
};

export { PayPalSection };
